// src/utils/jwtUtils.js

/**
 * Decode JWT token without verification
 * @param {string} token - JWT token string
 * @returns {object|null} - Decoded token payload or null if invalid
 */


export const decodeToken = (token) => {
  try {
    if (!token) return null;
    
    // JWT has three parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    // Decode the payload (second part)
    const payload = parts[1];
    const decoded = JSON.parse(atob(payload));
    
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

/**
 * Get user role from token
 * @param {string} token - JWT token string
 * @returns {string|null} - User role or null
 */
export const getUserRole = (token) => {
  const decoded = decodeToken(token);
  console.log(decoded);
  
  return decoded?.role || null;
};

/**
 * Get user ID from token
 * @param {string} token - JWT token string
 * @returns {string|null} - User ID or null
 */
export const getUserId = (token) => {
  const decoded = decodeToken(token);
  return decoded?.id || null;
};

/**
 * Check if token is expired
 * @param {string} token - JWT token string
 * @returns {boolean} - True if expired, false otherwise
 */
export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  
  // exp is in seconds, Date.now() is in milliseconds
  return decoded.exp * 1000 < Date.now();
};

/**
 * Check if user is admin
 * @param {string} token - JWT token string
 * @returns {boolean} - True if user is admin
 */
export const isAdmin = (token) => {
  const role = getUserRole(token);
  return role === 'admin';
};

/**
 * Check if user is customer
 * @param {string} token - JWT token string
 * @returns {boolean} - True if user is customer
 */
export const isCustomer = (token) => {
  const role = getUserRole(token);
  return role === 'customer';
};